






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuData } from './types';

@Component
export default class InnerMenu extends Vue {
  @Prop({ type: Array, required: true })
  readonly menu!: MenuData;

  @Prop({ type: Boolean, default: false })
  readonly showButton!: boolean;

  @Prop({ type: String, default: 'Новый запрос' })
  readonly buttonText!: string;

  get menuLinks() {
    return this.menu.filter(({ meta }) => {
      if (!meta) return false;
      const { title } = meta;
      return title && !!title.length;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/innermenu/InnerMenu.vue